<template>
    <div class="py-5">
        <div class="bg-white rounded-4 p-4 shadow-sm border">
            <h2 class="fs-36 ff-dsb text-primary text-center ms-auto mb-4">Browse by Make</h2>
            <div class="hstack flex-nowrap align-items-center make-swiper-wrap">
                <div class="swiper-prev text-primary fs-23 col-auto"><i class="fas fa-chevron-left"></i></div>
                <swiper-container class="col-11" :slides-per-view="2"
                    :navigation-next-el="'.make-swiper-wrap .swiper-next'"
                    :navigation-prev-el="'.make-swiper-wrap .swiper-prev'" :breakpoints="{
                        575: { slidesPerView: 3, },
                        768: { slidesPerView: 4, },
                        991: { slidesPerView: 5, },
                        1024: { slidesPerView: 6, },
                        1200: { slidesPerView: 8, },
                    }">
                    <swiper-slide v-for="make in $page.props.makes" class="h-auto">
                        <div class="text-center vstack h-100 px-3">
                            <Link class="fs-18 mb-0 h-100 d-flex flex-column make-swiper-link" :href="route('front.listings.all')" :method="get" :data="{ make: make.slug }">
                                <div class="mt-auto">
                                    <img class="img-fluid" :src="make.logo ?? '/images/front/make-placeholder.png'" />
                                </div>
                                <h5 class="fs-18 mb-0 mt-auto pt-2">{{ make.name }}</h5>
                            </Link>
                        </div>
                    </swiper-slide>
                </swiper-container>
                <div class="swiper-next text-primary fs-23 col-auto"><i class="fas fa-chevron-right"></i></div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { register } from 'swiper/element/bundle';
import { Link } from '@inertiajs/vue3';
register();
</script>
